import { useState, useEffect, useCallback } from "react";
import {CreateWeaponTraitDto, UpdateWeaponTraitDto, WeaponTrait} from "../model/Dto/Dict/Trait";
import {Api} from "../request/api/api";

export function useTraits() {
    const [traits, setTraits] = useState<WeaponTrait[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetchTraits = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.getAllTraits();
            setTraits(result);
        } catch (err) {
            setError("Ошибка загрузки списка свойств");
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, []);

    const createTrait = useCallback(async (data: CreateWeaponTraitDto) => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.createTrait(data);
            if (result) {
                await fetchTraits();
                return true;
            }
            setError("Ошибка создания свойства");
            return false;
        } catch (err) {
            setError("Ошибка создания свойства");
            console.error(err);
            return false;
        } finally {
            setLoading(false);
        }
    }, [fetchTraits]);

    const updateTrait = useCallback(async (id: string, data: UpdateWeaponTraitDto) => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.updateTrait(id, data);
            if (result) {
                await fetchTraits();
                return true;
            }
            setError("Ошибка обновления свойства");
            return false;
        } catch (err) {
            setError("Ошибка обновления свойства");
            console.error(err);
            return false;
        } finally {
            setLoading(false);
        }
    }, [fetchTraits]);

    const deleteTrait = useCallback(async (id: string) => {
        setLoading(true);
        setError(null);
        try {
            const result = await Api.dict.deleteTrait(id);
            if (result) {
                await fetchTraits();
                return true;
            }
            setError("Ошибка удаления свойства");
            return false;
        } catch (err) {
            setError("Ошибка удаления свойства");
            console.error(err);
            return false;
        } finally {
            setLoading(false);
        }
    }, [fetchTraits]);

    useEffect(() => {
        fetchTraits();
    }, [fetchTraits]);

    return { traits, loading, error, createTrait, updateTrait, deleteTrait, refetch: fetchTraits };
}